import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Grid as GridComponent } from './Grid';
export const Grid = withComponentMeta(GridComponent, createBuiltInComponentMeta('Grid'));
//# sourceMappingURL=index.js.map